<template>
  <div>
    <header-component/>

    <div class="container-fluid mt--6">
      <div class="card">
        <div class="card-header">
          <h3 
            class="mb-0" 
            style="text-transform:capitalize;">Labor Cost List</h3>
          <div class="col-lg-12 col-5 text-right">
            <base-button 
              size="sm" 
              type="primary" 
              @click="insertLaborCost">Add New</base-button>
          </div>
        </div>
        <el-table
          :data="laborCostList"
          class="table-responsive table-flush"
          header-row-class-name="thead-light"
        >
          <el-table-column 
            label="Description" 
            prop="description"/>
          <el-table-column label="Service">
            <template slot-scope="scope">
              <span v-if="scope.row.service">
                {{ scope.row.service.label }}
              </span>
            </template>
          </el-table-column>
          <el-table-column 
            label="Cost" 
            prop="cost"/>
          <el-table-column 
            min-width="70px" 
            label="Actions">
            <template slot-scope="scope">
              <el-dropdown 
                slot="dropdown" 
                @command="command => handleAction(scope.row, command)">
                <el-button 
                  type="primary" 
                  size="mini">
                  Actions
                  <i class="el-icon-arrow-down el-icon--right" />
                </el-button>
                <el-dropdown-menu 
                  slot="dropdown" 
                  class="dropdown-menu dropdown-menu-arrow show">
                  <el-dropdown-item command="edit">Edit</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog 
        :visible.sync="addLaborCost" 
        title="Add Labor Cost">
        <add-labor-cost @close="addLaborCost = false" />
      </el-dialog>
    </div>
  </div>
</template>
<script>
import headerComponent from "../Components/HeaderComponent";
import { mapActions, mapMutations, mapGetters } from "vuex";
import AddLaborCost from "./AddLaborCost";
import {
  Button,
  TableColumn,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Select,
  Dialog,
  DatePicker,
  Table,
  Option
} from "element-ui";
export default {
  components: {
    [Button.name]: Button,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Dialog.name]: Dialog,
    "add-labor-cost": AddLaborCost,
    "header-component": headerComponent
  },
  data: () => {
    return {
      addLaborCost: false
    };
  },

  computed: {
    ...mapGetters({
      laborCostList: "laborCost/getLaborCosts",
      getLaborCost: "laborCost/getgetLaborCost"
    })
  },

  mounted() {
    this.getLaborCosts();
  },

  methods: {
    ...mapActions({
      getLaborCosts: "laborCost/getLaborCosts",
      fetchlaborCost: "laborCost/fetchlaborCost"
    }),
    ...mapMutations({
      resetLaborCost: "laborCost/resetLaborCost",
      setlaborCost: "laborCost/setlaborCost"
    }),
    insertLaborCost() {
      this.resetLaborCost();
      this.addLaborCost = true;
    },
    handleAction(laborCost, command) {
      if (command === "edit") {
        this.fetchlaborCost(laborCost.laborCostId).then(res => {
          this.setlaborCost(res);
          this.addLaborCost = true;
        });
      }
    }
  }
};
</script>